import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {DjPsycho} from "../DjPsycho";
import {TimelineLite} from "gsap";
import {DjPsychoGameMode} from "../server/DjPsychoGameMode";
import {SimpleReelModel} from "../../core/reel/simplereel/SimpleReelModel";
import {DjPsychoSymbol} from "../reels/DjPsychoSymbol";

export class DjPsychoIdleNormalPresentation implements FlowStatePresentation {
    private static _tl: TimelineLite;

    // #148
    public static killTl(): void {
        if (this._tl) {
            this._tl.pause();
            this._tl.kill();
        }
    }

    public start(flowStateController: FlowStateController): void {
        DjPsychoIdleNormalPresentation._tl = new TimelineLite();

        // #148
        DjPsychoIdleNormalPresentation._tl.add(() => {
            DjPsycho.xBetView.enableButton(true);

            DjPsycho.reelView.reelModels.forEach((reel: SimpleReelModel) => {
                reel.symbols.forEach((sym: DjPsychoSymbol) => {
                    sym.enable(true);
                });
            });
        }, 0.15);

        if (DjPsycho.model.gameData?.nextMode !== DjPsychoGameMode.NORMAL) {
            flowStateController.finish();
            return;
        }

        flowStateController.finish();
    }
}